/* Meubelhunter — zelfstandige foto-lightbox (tap-to-zoom, finger-follow swipe, pinch, dubbeltik).
   Vervangt Empire's photoswipe voor de PDP-galerij:
   - hele foto opent de zoom (fixt dead-clicks),
   - géén photoswipe -> geen `this.photoswipe.close`-crash, betrouwbaar in in-app browsers,
   - werkt op de variant-galerij (mhvg) én op Empire's product-gallery,
   - veeg = echte track die je vinger volgt en soepel inklikt (zoals de mhvg-carousel).
   Raakt de mhvg-swaplogica NIET aan; dit is puur een extra laag. */
(function () {
  'use strict';

  var DUR = 280; // ms snap-animatie

  function galRoot() {
    return document.querySelector('[data-mhvg]') || document.querySelector('[data-product-gallery]');
  }
  if (!galRoot()) return;

  function baseUrl(u) { return (u || '').split('?')[0]; }

  function collect() {
    var mhvg = document.querySelector('[data-mhvg]');
    if (mhvg) {
      var map = {};
      var mEl = mhvg.querySelector('[data-mhvg-map]');
      if (mEl) { try { map = JSON.parse(mEl.textContent); } catch (e) {} }
      var sel = mhvg.getAttribute('data-mhvg-sel');
      var list = (map && map[sel]) || [];
      return list.map(function (o) { return { src: o.f, srcset: o.ss, alt: o.a || '' }; });
    }
    var figs = Array.prototype.filter.call(
      document.querySelectorAll('[data-product-gallery] [data-gallery-figure]'),
      function (fig) { var mt = fig.getAttribute('data-media-type'); return !mt || mt === 'image'; } // alleen foto's, geen video/3D
    );
    return figs.map(function (fig) {
      var img = fig.querySelector('img');
      return { src: fig.getAttribute('data-zoom') || (img && (img.currentSrc || img.src)) || '', srcset: null, alt: (img && img.alt) || '' };
    }).filter(function (o) { return o.src; });
  }

  function startIndexFrom(target, images) {
    var fig = target.closest && target.closest('[data-gallery-figure]');
    if (fig) {
      var figs = Array.prototype.slice.call(document.querySelectorAll('[data-product-gallery] [data-gallery-figure]'))
        .filter(function (f) { var mt = f.getAttribute('data-media-type'); return !mt || mt === 'image'; });
      var i = figs.indexOf(fig);
      if (i >= 0) return i;
    }
    var img = target.closest && target.closest('img');
    if (img) {
      var b = baseUrl(img.currentSrc || img.src);
      for (var k = 0; k < images.length; k++) if (baseUrl(images[k].src) === b) return k;
    }
    return 0;
  }

  function open(images, startIndex) {
    if (!images.length) return;
    var idx = Math.max(0, Math.min(startIndex || 0, images.length - 1));

    var ov = document.createElement('div');
    ov.className = 'mh-lb';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');

    var slides = images.map(function (im) {
      return '<div class="mh-lb__slide"><img class="mh-lb__img" src="' + im.src + '"' +
        (im.srcset ? ' srcset="' + im.srcset + '" sizes="96vw"' : '') +
        ' alt="' + (im.alt || '').replace(/"/g, '&quot;') + '" draggable="false"></div>';
    }).join('');

    ov.innerHTML =
      '<div class="mh-lb__backdrop" data-lb-close></div>' +
      '<button type="button" class="mh-lb__close" data-lb-close aria-label="Sluiten"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="mh-lb__counter" data-lb-counter></div>' +
      '<button type="button" class="mh-lb__nav mh-lb__nav--prev" data-lb-prev aria-label="Vorige foto"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>' +
      '<button type="button" class="mh-lb__nav mh-lb__nav--next" data-lb-next aria-label="Volgende foto"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></button>' +
      '<div class="mh-lb__stage" data-lb-stage><div class="mh-lb__track" data-lb-track>' + slides + '</div></div>';
    document.body.appendChild(ov);
    document.body.classList.add('mh-lb-open');

    var stage = ov.querySelector('[data-lb-stage]');
    var track = ov.querySelector('[data-lb-track]');
    var counter = ov.querySelector('[data-lb-counter]');
    var imgs = Array.prototype.slice.call(ov.querySelectorAll('.mh-lb__img'));

    var W = 0;
    function measure() { W = stage.getBoundingClientRect().width || window.innerWidth; }
    measure();

    function setX(px, animate) {
      track.style.transition = animate ? ('transform ' + DUR + 'ms cubic-bezier(.22,.61,.36,1)') : 'none';
      track.style.transform = 'translate3d(' + px + 'px,0,0)';
    }
    function place(animate) { setX(-idx * W, animate); }

    // per-slide zoom/pan
    var scale = 1, tx = 0, ty = 0;
    function applyZoom() { if (imgs[idx]) imgs[idx].style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
    function resetZoom() { scale = 1; tx = 0; ty = 0; if (imgs[idx]) imgs[idx].style.transform = ''; }

    function show(i, animate) {
      resetZoom();
      idx = (i + images.length) % images.length;
      place(animate);
      counter.textContent = (idx + 1) + ' / ' + images.length;
      var nav = images.length > 1 ? '' : 'none';
      var navs = ov.querySelectorAll('.mh-lb__nav');
      for (var q = 0; q < navs.length; q++) navs[q].style.display = nav;
      counter.style.display = nav;
    }

    function close() {
      ov.remove();
      document.body.classList.remove('mh-lb-open');
      document.removeEventListener('keydown', onKey);
      window.removeEventListener('resize', onResize);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(idx + 1, true);
      else if (e.key === 'ArrowLeft') show(idx - 1, true);
    }
    var rt;
    function onResize() { clearTimeout(rt); rt = setTimeout(function () { measure(); resetZoom(); place(false); }, 120); }
    document.addEventListener('keydown', onKey);
    window.addEventListener('resize', onResize);

    ov.addEventListener('click', function (e) {
      if (e.target.closest('[data-lb-close]')) { close(); }
      else if (e.target.closest('[data-lb-prev]')) { e.stopPropagation(); show(idx - 1, true); }
      else if (e.target.closest('[data-lb-next]')) { e.stopPropagation(); show(idx + 1, true); }
    });

    // ---- touch ----
    var d = { drag: false, pinch: false, decided: false, horiz: false, sx: 0, sy: 0, base: 0,
              startTx: 0, startTy: 0, startDist: 0, startScale: 1, lastTap: 0, moved: false };
    function dist(a, b) { var dx = a.clientX - b.clientX, dy = a.clientY - b.clientY; return Math.sqrt(dx * dx + dy * dy); }
    function clampPan() {
      var r = imgs[idx].getBoundingClientRect();
      var mx = Math.max(0, (r.width - stage.clientWidth) / 2 + 30);
      var my = Math.max(0, (r.height - stage.clientHeight) / 2 + 30);
      tx = Math.max(-mx, Math.min(mx, tx)); ty = Math.max(-my, Math.min(my, ty));
    }

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        d.pinch = true; d.drag = false;
        d.startDist = dist(e.touches[0], e.touches[1]); d.startScale = scale;
      } else if (e.touches.length === 1) {
        measure();
        d.drag = true; d.pinch = false; d.decided = false; d.horiz = false; d.moved = false;
        d.sx = e.touches[0].clientX; d.sy = e.touches[0].clientY;
        d.base = -idx * W; d.startTx = tx; d.startTy = ty;
      }
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (d.pinch && e.touches.length === 2) {
        e.preventDefault();
        scale = Math.max(1, Math.min(4, d.startScale * (dist(e.touches[0], e.touches[1]) / (d.startDist || 1))));
        applyZoom();
        return;
      }
      if (!d.drag || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - d.sx, dy = e.touches[0].clientY - d.sy;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) d.moved = true;
      if (scale > 1) {                       // ingezoomd -> pannen
        e.preventDefault();
        tx = d.startTx + dx; ty = d.startTy + dy; clampPan(); applyZoom();
        return;
      }
      if (!d.decided) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        d.decided = true; d.horiz = Math.abs(dx) > Math.abs(dy);
      }
      if (!d.horiz) return;                   // verticaal -> laat sluit-gebaar/scroll met rust
      e.preventDefault();
      setX(d.base + dx, false);               // finger-follow
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      try {
      if (d.pinch) { d.pinch = false; if (scale <= 1.02) resetZoom(); return; }
      if (!d.drag) return; d.drag = false;
      if (scale > 1) { clampPan(); applyZoom(); return; }
      var endX = (e.changedTouches[0] || {}).clientX;
      var dx = (endX == null ? 0 : endX - d.sx);
      // dubbeltik -> zoom
      if (!d.moved) {
        var now = Date.now();
        if (now - d.lastTap < 300) { scale = 2.4; applyZoom(); d.lastTap = 0; }
        else d.lastTap = now;
        return;
      }
      if (d.horiz) {
        var th = Math.min(70, W * 0.18);
        if (dx <= -th && idx < images.length - 1) show(idx + 1, true);
        else if (dx >= th && idx > 0) show(idx - 1, true);
        else place(true);                     // te klein of aan de rand -> terugveren
      }
      } catch (e2) { if (window.console) console.warn('[mh-lightbox]', e2); }
    }, { passive: true });

    // desktop dubbelklik zoomt
    stage.addEventListener('dblclick', function () { if (scale > 1) resetZoom(); else { scale = 2.4; applyZoom(); } });

    show(idx, false);
  }

  // trigger: tik op een galerij-foto (capture -> vóór Empire's photoswipe)
  document.addEventListener('click', function (e) {
    try {
      if (!galRoot()) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var inGallery = t.closest('[data-mhvg] .mhvg__slide, [data-mhvg] img, [data-product-gallery] [data-gallery-figure], [data-product-gallery] .product-gallery--expand, [data-gallery-expand]');
      if (!inGallery) return;
      if (t.closest('[data-mhvg-thumb], [data-gallery-thumbnail], [data-gallery-navigation]')) return;
      // Video/3D-media niet onderscheppen -> de native play-knop blijft werken.
      var clickedFig = t.closest('[data-gallery-figure]');
      if (clickedFig) { var cmt = clickedFig.getAttribute('data-media-type'); if (cmt && cmt !== 'image') return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      var images = collect();
      open(images, startIndexFrom(t, images));
    } catch (err) { if (window.console) console.warn('[mh-lightbox]', err); }
  }, true);
})();
